import React, { useEffect, useState } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import { Skeleton, Alert } from "antd";
import { getElemento } from "../../../services/constituicaoAPI";

/**
 * Redireciona /legislacao/federal/elemento/:id para /legislacao/federal/:url
 * quando o breadcrumb ou links só têm o ID disponível.
 */
export default function ConstituicaoRedirectPorId() {
  const { id } = useParams();
  const history = useHistory();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) return;
    let cancelled = false;

    (async () => {
      try {
        const el = await getElemento(id, false);
        if (cancelled) return;
        if (el?.url) {
          history.replace(`/legislacao/federal/${el.url}`);
        } else {
          setError("Elemento não possui URL");
        }
      } catch (err) {
        if (!cancelled) setError(err?.message || "Erro ao carregar");
      }
    })();

    return () => { cancelled = true; };
  }, [id, history]);

  if (error) {
    return (
      <div className="container mt-5 mb-5">
        <Alert type="error" message={error} showIcon />
        <Link to="/legislacao/federal" style={{ display: "block", marginTop: 16 }}>
          ← Voltar ao sumário
        </Link>
      </div>
    );
  }

  return (
    <div className="container mt-5 mb-5">
      <Skeleton active paragraph={{ rows: 4 }} />
    </div>
  );
}
